/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementClipFilterRequest { 
    publicationDateFrom?: number;
    publicationDateTo?: number;
    types?: Array<ManagementClipFilterRequest.TypesEnum>;
    searchText?: string;
    clientId?: string;
    visibilityIndexFrom?: number;
    visibilityIndexTo?: number;
    sentimentScoreFrom?: number;
    sentimentScoreTo?: number;
    mediumId?: string;
    authorId?: string;
    tagIds?: Array<string>;
    createdAtFrom?: number;
    createdAtTo?: number;
    noTags?: boolean;
    onlyTagged?: boolean;
    autoTagged?: boolean;
    autoGrouped?: boolean;
    main?: boolean;
}
export namespace ManagementClipFilterRequest {
    export type TypesEnum = 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    export const TypesEnum = {
        PRINTED: 'PRINTED' as TypesEnum,
        WEB: 'WEB' as TypesEnum,
        TV: 'TV' as TypesEnum,
        RADIO: 'RADIO' as TypesEnum,
        SOCIAL: 'SOCIAL' as TypesEnum
    };
}